import React from "react";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";

// Define the type for each row in the data array
interface DataRow {
    title: string;
    level: string;
    count: number;
}

// Define the props for the component
interface AssetsTableProps {
    data: DataRow[]; // Array of DataRow objects
}

// Define a mapping of levels to colors with transparency
const levelColors: Record<string, string> = {
    Critical: "rgba(224,0,0,0.3)", // Light red with 30% transparency
    "Very High": "rgba(255,122,122,0.3)", // Light orange with 30% transparency
    High: "rgba(147,103,0,0.3)", // Light green with 30% transparency
    Medium: "rgba(252,215,103,0.3)", // Light blue with 30% transparency
    Low: "rgba(185,245,0,0.3)", // Light gray with 30% transparency
};

export default function AssetsTable({data = []}: AssetsTableProps) {
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Title</TableCell>
                        <TableCell>Level</TableCell>
                        <TableCell align="right">Count</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow
                            key={index}
                            sx={{
                                backgroundColor: levelColors[row.level] || "#ffffff", // Default to white if level is not found
                            }}
                        >
                            <TableCell>{row.title}</TableCell>
                            <TableCell>{row.level}</TableCell>
                            <TableCell align="right">{row.count}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}